export default __webpack_public_path__ + "static/media/svg5.eb2f6463.svg";